var path = 'src/app/ui/live-warning.html';
var html = "<div class=header-alert ng-if=!live> <i class=\"fa fa-exclamation-circle\"></i> This is not the live version of RaDaR. Please do not enter any patient identifiable data. </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/live-warning.html
// module id = 656
// module chunks = 0